export enum CartPanelMode {
  Add = 'add',
  Edit = 'edit',
}
